<template>
  <v-dialog
    v-model="dialog"
    width="400px">
    <div class="header flex">
      <p>New Redeem</p>
      <font-awesome-icon
        icon="times"
        class="close"
        @click="handleCancel"></font-awesome-icon>
    </div>
    <div class="body">
      <div class="top">
        The customer must have an existing Binance account.
      </div>
      <div class="main flex">
        <div class="hd">
          <div class="money-name">Hold Dollars</div>
          <div class="money">Balance: {{balance}}</div>
        </div>

        <div class="input">
          <v-input
            v-model="transfer.money"
            money
            int></v-input>
        </div>

        <font-awesome-icon
          icon="long-arrow-alt-down"
          class="arrow"></font-awesome-icon>
        
        <div
          class="currency"
          :class="{'del-line': !refreshed}">
          {{transferCompute}} BUSD
        </div>
        <div
          class="ratio"
          :class="{'del-line': !refreshed}">
          1 HK$ = {{price}} BUSD
        </div>

        <div class="payid">
          <p>Binance Pay ID</p>
          <v-input v-model="transfer.number"></v-input>
        </div>
      </div>
      <div class="footer">
        <div class="tips">
          <span v-if="refreshed">
            Conversion rate expires in {{second}}s
          </span>
          <span v-else>
            Refreshing conversion rate...
          </span>
        </div>
        <div class="btn flex">
          <v-button
            class="cancel"
            @click="handleCancel">Cancel</v-button>
          <v-button
            class="redeem"
            @click="handleRedeem">Redeem</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {getCurrencys, getCurrencysPrice, binanceTransfer} from '@/api/referral'
export default {
  name: 'RedeemDialog',
  props:{
    balance:{
      type: [Number, String],
      default: 0
    },
    customerId:{
      type: [Number, String],
      default: 0
    },
    binancePayId:{
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      second: 60,
      timer: null,
      refreshed: true,
      asset_digit: 0,
      price: '',
      transfer:{
        currency: '',
        money: '',
        ratio: '',
        number: ''
      }
    }
  },
  computed:{
    transferCompute(){
      return (this.transfer.money * this.price).toFixed(this.asset_digit)
    }
  },
  watch:{
    dialog:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getCurrencys()
          this.second = 60
          this.countDown()
        }else{
          this.clearTimer()
        }
      }
    },
    binancePayId:{
      immediate: true,
      handler(val){
        this.transfer.number = val
      }
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },
    handleCancel(){
      this.changeDialog()
    },
    handleRedeem(){
      this.network().binanceTransfer()
    },

    countDown(){
      if(this.timer === null){
        this.timer = setInterval(() => {
          this.second -- 
          if(this.second === 0){
            this.network().getCurrencys()
          }
        },1000)
      }
    },

    clearTimer(){
      clearInterval(this.timer)
      this.timer = null
    },

    network(){
      return {
        getCurrencys: async () => {
          this.refreshed = false
          this.clearTimer()
          const {data} = await getCurrencys()
          if(data.length){
            this.transfer.currency = data[0].currency
            this.asset_digit = data[0].asset_digit
            this.network().getCurrencysPrice({
              currency: this.transfer.currency
            })
            this.refreshed = true
            this.second = 60
            this.countDown()
          }else{
            this.network().getCurrencys()
          }
        },

        getCurrencysPrice: async (params)=> {
          const {data} = await getCurrencysPrice(params)
          this.transfer.ratio = data.ratio
          this.price = data.price
        },

        binanceTransfer: async () => {
          let params = {
            ...this.transfer,
            customer_id: this.customerId
          }
          const {data} = await binanceTransfer(params)
          if(data.status === 'SUCCESS'){
            this.changeDialog()
            this.transfer.money = ''
            this.transfer.number = ''
            this.$emit('update')
            this.$message({
              type: 'success',
              message: data.status_language
            })
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .body{
    padding: 20px 15px 15px 15px;
    .top{
      color: #24292E;
    }
    .main{
      padding: 20px 0;
      flex-direction: column;
      .hd{
        width: 100%;
        margin-bottom: 8px;
        .money-name{
          float: left;
          font-weight: 600;
          color: #24292E;
        }
        .money{
          float: right;
          color: #6A737D;
          font-size: 12px;
        }
      }
      .arrow{
        margin: 10px 0;
      }
      .currency{
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
        letter-spacing: 0.3px;
        color: #22863A;
      }
      .ratio{
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #6A737D;
        margin: 2px 0 20px 0;
      }
      .del-line{
        text-decoration:line-through
      }
      .payid{
        p{
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.15px;
          color: #24292E;
          margin-bottom: 8px;
        }
      }
    }
    .footer{
      .tips{
        text-align: center;
        color: #6A737D;
      }
      .btn{
        margin-top: 10px;
        justify-content: space-between;
        .cancel{
          background: #FAFBFC;
          border: 1px solid rgba(27, 31, 35, 0.15);
          box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
          border-radius: 6px;
          .btn-label{
            font-weight: 600;
            align-items: center;
            letter-spacing: -0.15px;
            color: #24292E;
          }
        }
        .redeem{
          background: #2EA44F;
          border: 1px solid rgba(27, 31, 35, 0.15);
          box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
          border-radius: 6px;
          .btn-label{
            font-weight: 600;
            align-items: center;
            letter-spacing: -0.15px;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>
